import React, { useMemo } from 'react';

import AllDashboardGadgetsGate from 'components/AllDashboardGadgetsGate';

import usePopupReports, { PopupReportUsage } from './usePopupReports';

export const PopupReportUsageLookupContext = React.createContext<{
  popupReportsLookup: { [key: string]: PopupReportUsage[] | undefined };
}>({
  popupReportsLookup: {},
});

const PopupReportUsageLookupProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const popupReports = usePopupReports({ onlyFromPublishedSources: false });
  const popupReportsLookup = useMemo((): {
    [key: string]: PopupReportUsage[] | undefined;
  } => {
    const lookup: { [key: string]: PopupReportUsage[] | undefined } = {};

    popupReports.forEach(({ report, usage }) => {
      lookup[report.id] = usage;
    });

    return lookup;
  }, [popupReports]);

  return (
    <PopupReportUsageLookupContext.Provider value={{ popupReportsLookup }}>
      {children}
    </PopupReportUsageLookupContext.Provider>
  );
};

/**
 * Not mounted app-wide: the lookup needs every dashboard gadget loaded, which
 * is expensive. Mount it around the UI that needs it, only once that UI is
 * shown (e.g. inside a modal).
 */
const Gate = ({ children }: { children: React.ReactNode }) => (
  <AllDashboardGadgetsGate>
    <PopupReportUsageLookupProvider>{children}</PopupReportUsageLookupProvider>
  </AllDashboardGadgetsGate>
);

export default Gate;
